import styled, { css } from 'styled-components'
import { ButtonUnstyled } from 'components/Button/ButtonUnstyled'
import { ReactComponent as MagGlassSvg } from 'icons/mag-glass-24.svg'
import { ReactComponent as CrossSvg } from 'icons/cross-circle-24.svg'
import { breakpoint } from 'utils'
import Input from 'components/Input'

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 32px;
`

export const iconStyles = css`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.woodsmoke};
  }

  &:active {
    color: ${({ theme }) => theme.colors.text.dark.primary};
  }
`

export const LoupeIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;

  width: 24px;
  height: 24px;

  margin: 4px 8px;
`

export const LoupeIcon = styled(MagGlassSvg).attrs({
  role: 'img',
  'aria-label': 'Search',
})(
  ({ theme }) => css`
    width: 14px;
    height: 14px;

    transition: all
      ${`${theme.transitions.duration[2]} ${theme.transitions.timing.easeInOut}`};

    ${iconStyles}

    color: ${theme.colors.foreground.secondary[4]};
  `
)

export const ClearButton = styled(ButtonUnstyled)`
  width: 24px;
  height: 24px;
  margin: 4px 8px;
`

export const CrossIcon = styled(CrossSvg).attrs({
  role: 'img',
  'aria-label': 'Clear',
})(
  ({ theme }) => css`
    width: 16px;
    height: 16px;
    margin: 0 -3px 0 8px; /* stylelint-disable-line scales/space */
    color: ${theme.colors.gray};

    ${iconStyles};
  `
)

export const SearchInput = styled(Input)(
  ({ theme }) => css`
    position: absolute;
    left: 0;
    top: 0;
    height: 32px;

    &[type='text'] {
      font-size: ${theme.fontSizes.smaller};
      border-radius: ${theme.radii.large};
      border: 1px solid ${theme.colors.border[2]};
      padding-left: 40px;
      padding-right: 40px;
    }
  `
)

export const Form = styled.form<{ width?: number }>(
  ({ theme, width }) => css`
    width: 100%;

    transition: all
      ${`${theme.transitions.duration[2]} ${theme.transitions.timing.easeInOut}`};

    ${Input} {
      opacity: 1;
    }

    ${typeof width !== 'undefined' &&
    breakpoint('sm')`
        width: ${width}px;
    `};
  `
)

export const ClearButtonAndChildrenWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`
